import { render, staticRenderFns } from "./default-taxi.vue?vue&type=template&id=2f9cbf6c"
import script from "./default-taxi.vue?vue&type=script&lang=js"
export * from "./default-taxi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports